import { Badge } from "react-bootstrap";
import PropTypes from "prop-types";
import GenericScrollTable from "./GenericScrollTable";

function UltimasAtencionesTable({ atenciones, title = "Últimas Atenciones" }) {
  // Mapeo de carreras
  const carrerasMap = {
    "PC": "Plan Común",
    "DCC": "Ing. Informática",
    "DFI": "Ing. Física",
    "DAS": "Ing. Astronomía",
    "DGF": "Ing. Geofísica",
    "DG": "Ing. Geología",
    "DIC": "Ing. Civil",
    "IQBT": "Ing. Química",
    "DIE": "Ing. Eléctrica",
    "DII": "Ing. Industrial",
    "DIM": "Ing. Matemática",
    "DIMEC": "Ing. Mecánica",
    "DIMIN": "Ing. de Minas",
  };

  // Mapeo de estado a colores
  const estadoColors = {
    "finalizada": "success",
    "en-proceso": "warning",
  };

  // Definición de columnas
  const columns = [
    {
      key: "fecha",
      header: "Fecha",
      cellClassName: "text-muted",
      render: (row) => row.fecha
    },
    {
      key: "hora",
      header: "Hora",
      cellClassName: "text-muted",
      style: { minWidth: "140px" },
      render: (row) => (
        <>
          {row.hora_inicio}
          {row.hora_fin && ` - ${row.hora_fin}`}
        </>
      )
    },
    {
      key: "estudiante_nombre",
      header: "Estudiante",
      cellClassName: "fw-semibold",
      render: (row) => row.estudiante_nombre
    },
    {
      key: "estudiante_rut",
      header: "RUT",
      cellClassName: "text-muted",
      render: (row) => row.estudiante_rut
    },
    {
      key: "estudiante_carrera",
      header: "Carrera",
      render: (row) => carrerasMap[row.estudiante_carrera] || row.estudiante_carrera
    },
    {
      key: "motivo",
      header: "Motivo",
      render: (row) => (
        <span className="badge bg-light text-dark">
          {row.motivo}
        </span>
      )
    },
    {
      key: "funcionario",
      header: "Funcionario",
      cellClassName: "text-muted",
      render: (row) => row.funcionario
    },
    {
      key: "duracion",
      header: "Duración",
      className: "text-center",
      cellClassName: "text-center",
      render: (row) => (
        row.duracion ? (
          <span
            className="badge rounded-pill"
            style={{
              backgroundColor: "#e3f2fd",
              color: "#1976d2",
              fontSize: "0.85rem",
              padding: "4px 10px",
            }}
          >
            {row.duracion} min
          </span>
        ) : (
          <span className="text-muted">-</span>
        )
      )
    },
    {
      key: "estado",
      header: "Estado",
      className: "text-center",
      cellClassName: "text-center",
      render: (row) => (
        <Badge bg={estadoColors[row.estado] || "secondary"}>
          {row.estado === 'finalizada' ? 'Finalizada' : 'En Proceso'}
        </Badge>
      )
    }
  ];

  // Manejar click en fila
  const handleRowClick = (row, index, navigate) => {
    navigate(`/atencion/ficha/${row.estudiante_id}`);
  };

  return (
    <GenericScrollTable
      data={atenciones}
      columns={columns}
      title={title}
      icon="bi-clock-history"
      initialItems={10}
      incrementItems={10}
      height="400px"
      onRowClick={handleRowClick}
      emptyMessage="No hay atenciones disponibles"
    />
  );
}

UltimasAtencionesTable.propTypes = {
  atenciones: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      fecha: PropTypes.string,
      hora_inicio: PropTypes.string,
      hora_fin: PropTypes.string,
      duracion: PropTypes.number,
      estudiante_id: PropTypes.number,
      estudiante_nombre: PropTypes.string,
      estudiante_rut: PropTypes.string,
      estudiante_carrera: PropTypes.string,
      motivo: PropTypes.string,
      funcionario: PropTypes.string,
      estado: PropTypes.string,
      comentario: PropTypes.string,
    })
  ),
  title: PropTypes.string,
};

export default UltimasAtencionesTable;
